'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _CloseIcon = require('../../icons/CloseIcon');

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

var _reactMotion = require('react-motion');

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ANIMATION_DEFAULTS = {
  stiffness: 220,
  damping: 26
};

var ActionBar = function ActionBar(_ref) {
  var title = _ref.title,
      type = _ref.type,
      actions = _ref.actions,
      onClose = _ref.onClose,
      style = _ref.style,
      isOpen = _ref.isOpen;

  var mainStyles = (0, _classnames3.default)(_styles2.default.action_bar, _defineProperty({}, _styles2.default['action_bar--' + type], type));

  return isOpen && _react2.default.createElement(
    'div',
    { className: mainStyles, style: style },
    _react2.default.createElement(
      _reactMotion.Motion,
      {
        defaultStyle: { opacity: 0 },
        style: { opacity: (0, _reactMotion.spring)(1, ANIMATION_DEFAULTS) }
      },
      function (interpolatedStyles) {
        return _react2.default.createElement(
          'div',
          { className: _styles2.default['action_bar--internal'], style: interpolatedStyles },
          _react2.default.createElement(
            'div',
            {
              onClick: onClose,
              className: _styles2.default.close_button__container
            },
            _react2.default.createElement(_CloseIcon2.default, { className: _styles2.default.close_icon, size: 'medium' })
          ),
          _react2.default.createElement('div', { className: _styles2.default.close_border }),
          _react2.default.createElement(
            'div',
            { className: _styles2.default.action_bar__wrapper },
            _react2.default.createElement(
              'div',
              { className: _styles2.default.title },
              title
            ),
            _react2.default.createElement(
              'div',
              { className: _styles2.default.action_section },
              _react.Children.map(actions, function (action) {
                return _react2.default.createElement(
                  'div',
                  { className: _styles2.default.action_container },
                  (0, _react.cloneElement)(action, { size: 'medium', type: type })
                );
              })
            )
          )
        );
      }
    )
  );
};

ActionBar.propTypes = {
  isOpen: _react.PropTypes.bool,
  title: _react.PropTypes.string.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  style: _react.PropTypes.object,
  type: _react.PropTypes.oneOf(['primary', 'success', 'destructive']),
  actions: _react.PropTypes.arrayOf(_react.PropTypes.element)
};

ActionBar.defaultProps = {
  type: 'primary'
};

exports.default = ActionBar;